import { render, staticRenderFns } from "./CustomerTags.vue?vue&type=template&id=e812ae78&scoped=true"
import script from "./CustomerTags.vue?vue&type=script&lang=js"
export * from "./CustomerTags.vue?vue&type=script&lang=js"
import style0 from "./CustomerTags.vue?vue&type=style&index=0&id=e812ae78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e812ae78",
  null
  
)

export default component.exports